import { Box, Grid } from "@mui/material";
import { Tabs } from "antd";
import { useSnackbar } from "notistack";
import { useEffect, useMemo, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import NunitoText from "../components/general/NunitoText";
import ReusableButton from "../components/general/ReusableButton";
import ReusableSelect from "../components/general/ReusableSelect";
import ReusableTextField from "../components/general/ReusableTextField";
import { showWarningSwal } from "../functions/alert";
import { getCompetition } from "../functions/getData";
import {
  // uploadTeamMembersCsv,
  submitTeamMembersForTeamCompetition,
} from "../functions/postData";
import { showNotification } from "../functions/snackbar";

export default function ConfigureTeamMembersInTeamCompetitions() {
  let location = useLocation();

  const controller = useMemo(() => new AbortController(), []);
  const signal = controller.signal;
  const [contestName, setName] = useState("");
  const [competition, setCompetition] = useState([]);
  document.title = "Configure Team Members";
  const [round, setRound] = useState();
  const [levelOptions, setLevelOptions] = useState([]);

  // Updated state for multiple teams
  const [teams, setTeams] = useState([
    {
      id: 1,
      division: "",
      teamNumber: "",
      participants: ["", "", "", "", ""],
      isMinimized: false,
    },
  ]);

  const [csvFile, setCSVFile] = useState(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (location.search.slice(0, 4) === "?id=") {
      getCompetition(`/${Number(location.search.slice(4))}`, signal).then(
        (res) => {
          const competition = res;
          setRound(competition.rounds[0].id);
          setName(competition.name);
          setCompetition(res);
        }
      );
    }
    return () => {
      controller.abort();
    };
  }, [controller, signal]);

  useEffect(() => {
    if (competition.rounds) {
      let levelOptionss = [];
      competition.rounds.map((round, index) => {
        round.levels.map((el) => {
          let obj = { id: el.id, option: `round${index + 1} ${el.name}` };
          levelOptionss.push(obj);
        });
      });
      setLevelOptions(levelOptionss);
    }
  }, [competition, setName]);

  const tabStyle = `
    .custom-tabs .ant-tabs-tab {
      flex: 1;
      justify-content: center;
      text-align: center;
      color: #5E74C2;
      background-color:rgb(215, 215, 215)  !important;
    }

    .custom-tabs .ant-tabs-nav-list {
      display: flex;
      width: 100%;
    }

    .custom-tabs .ant-tabs-tab-active {
      background-color: #5E74C2 !important;
      border-radius: 12px 12px 0 0;
      font-weight: bold;
    }

    .custom-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #ffffff !important;
  }
  `;

  const downloadSampleCsvTemplate = () => {
    // Create headers array
    const headers = [
      "Division",
      "Team Number",
      "Participant 1",
      "Participant 2",
      "Participant 3",
      "Participant 4",
      "Participant 5",
    ];

    // Create CSV content with headers and 5 empty rows
    const csvContent = [
      headers.join(","),
      ",,,,,,,,,",
      ",,,,,,,,,",
      ",,,,,,,,,",
      ",,,,,,,,,",
      ",,,,,,,,,",
    ].join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "team-members-template.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleUploadTeamMembersCsv = async () => {
    try {
      if (!csvFile) {
        showWarningSwal("Please select a file first");
        return;
      }
      // Parse CSV file
      const reader = new FileReader();
      reader.onload = async (event) => {
        const csvText = event.target.result;
        const rows = csvText.split("\n").map((row) => row.trim());

        // Skip header row and filter out empty rows
        const dataRows = rows.slice(1).filter((row) => row.length > 0);

        // Parse each row into required format
        const parsedTeams = dataRows.map((row) => {
          const [division, teamNumber, ...participants] = row
            .split(",")
            .map((cell) => cell.trim());
          return {
            division,
            team_number: teamNumber,
            participants: participants.filter((p) => p !== ""), // Remove empty participant slots
          };
        });

        await handleSaveTeamMembers(parsedTeams);
      };

      reader.readAsText(csvFile);

      // const response = await uploadTeamMembersCsv(csvFile);
      showNotification(
        "success",
        "File uploaded successfully",
        enqueueSnackbar,
        closeSnackbar
      );
      // Clear the file after successful upload
      setCSVFile(null);
    } catch (err) {
      console.error("MW upload error:", err);
      showWarningSwal(err.message || "Error uploading file. Please try again.");
    }
  };

  const handleTeamMembersCsvFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (
      selectedFile &&
      [
        "text/csv",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ].includes(selectedFile.type)
    ) {
      setCSVFile(selectedFile);
    } else {
      alert("Only CSV or XLSX files are allowed");
    }
  };

  const handleSaveTeamMembers = async (teams) => {
    try {
      const allTeamsData = teams.map((team) => {
        return {
          division: team.division,
          team_number: team.teamNumber,
          participants: team.participants.filter(
            (participant) => participant !== ""
          ),
        };
      });

      const response = await submitTeamMembersForTeamCompetition(allTeamsData);

      showNotification(
        "success",
        `Team members saved successfully for ${teams.length} team(s)`,
        enqueueSnackbar,
        closeSnackbar
      );
    } catch (err) {
      console.error("Save team members error:", err);
      showWarningSwal(
        err.message || "Error saving team members. Please try again."
      );
    }
  };

  const addExtraTeam = () => {
    const newTeamId = Math.max(...teams.map((t) => t.id)) + 1;
    setTeams([
      ...teams,
      {
        id: newTeamId,
        division: "",
        teamNumber: "",
        participants: ["", "", "", "", ""],
        isMinimized: false,
      },
    ]);
  };

  const updateTeam = (teamId, field, value) => {
    setTeams(
      teams.map((team) =>
        team.id === teamId ? { ...team, [field]: value } : team
      )
    );
  };

  const updateTeamParticipant = (teamId, participantIndex, value) => {
    setTeams(
      teams.map((team) => {
        if (team.id === teamId) {
          const newParticipants = [...team.participants];
          newParticipants[participantIndex] = value;
          return { ...team, participants: newParticipants };
        }
        return team;
      })
    );
  };

  const toggleTeamMinimize = (teamId) => {
    setTeams(
      teams.map((team) =>
        team.id === teamId ? { ...team, isMinimized: !team.isMinimized } : team
      )
    );
  };

  const removeTeam = (teamId) => {
    if (teams.length > 1) {
      const newTeams = teams.filter((team) => team.id !== teamId);
      console.log("New teams after removal:", newTeams);
      setTeams(newTeams);
    } else {
      console.log("Cannot remove team - only one team left");
    }
  };

  return (
    <Box style={{ flexGrow: 1 }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ paddingInline: 42, marginTop: 30 }}
      >
        <NunitoText
          value={`${contestName} - Configure Team Members`}
          fontSize={40}
          fontWeight={700}
          italic
          color="#144A94"
        />
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ marginTop: 30, width: "100%" }}
        ></Grid>
        <style>{tabStyle}</style>
        <Tabs
          className="custom-tabs"
          defaultActiveKey="ManualEntry"
          type="card"
          size="large"
          style={{
            marginBottom: 32,
            width: "100%",
            border: "2px solid #5E74C2",
            borderRadius: "8px",
          }}
          items={[
            {
              label: "Manual Entry",
              key: "ManualEntry",
              children: (
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ padding: 20 }}
                >
                  <Grid container spacing={1} style={{ width: "100%" }}>
                    {teams.map((team, teamIndex) => (
                      <Grid item xs={12} key={team.id}>
                        <div
                          style={{
                            border: "2px solid #144A94",
                            borderRadius: "8px",
                            padding: "20px",
                            marginBottom: "20px",
                            backgroundColor: "#f8f9fa",
                          }}
                        >
                          {/* Team Header with Minimize/Remove buttons */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "15px",
                              paddingBottom: "10px",
                              borderBottom: "1px solid #dee2e6",
                            }}
                          >
                            <NunitoText
                              value={`Team ${team.id}`}
                              fontSize={24}
                              fontWeight={700}
                              color="#144A94"
                            />
                            <div style={{ display: "flex", gap: "10px" }}>
                              <ReusableButton
                                text="Remove"
                                bgColor="#dc3545"
                                fontSize={14}
                                height={35}
                                width={100}
                                onClick={() => removeTeam(team.id)}
                                allowSpam={true}
                              />
                              <button
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  backgroundColor: "#6c757d",
                                  border: "none",
                                  borderRadius: "14px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#FFF",
                                }}
                                onClick={() => toggleTeamMinimize(team.id)}
                              >
                                {team.isMinimized ? (
                                  <FaChevronDown style={{ fontSize: "20px" }} />
                                ) : (
                                  <FaChevronUp style={{ fontSize: "20px" }} />
                                )}
                              </button>
                            </div>
                          </div>

                          {!team.isMinimized && (
                            <>
                              {/* Division Dropdown */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "15px",
                                }}
                              >
                                <div style={{ width: "12%", marginTop: 0 }}>
                                  <NunitoText
                                    value="Division"
                                    fontSize={20}
                                    fontWeight={600}
                                    align="left"
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "4%",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 2,
                                      height: 20,
                                      backgroundColor: "#000",
                                    }}
                                  />
                                </div>
                                <div style={{ width: "84%", marginTop: 0 }}>
                                  <ReusableSelect
                                    type="filter"
                                    width={250}
                                    bgColor="#F2F2F2"
                                    borderColor="#707070"
                                    label="Division"
                                    state={team.division}
                                    setState={(value) =>
                                      updateTeam(team.id, "division", value)
                                    }
                                    options={[
                                      {
                                        value: "UP",
                                        option: "Upper Primary Division",
                                      },
                                      {
                                        value: "LP",
                                        option: "Lower Primary Division",
                                      },
                                      {
                                        value: "LS",
                                        option: "Lower Secondary Division",
                                      },
                                      {
                                        value: "US",
                                        option: "Upper Secondary Division",
                                      },
                                    ]}
                                  />
                                </div>
                              </div>

                              {/* Team Number Input */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "15px",
                                }}
                              >
                                <div style={{ width: "12%", marginTop: 0 }}>
                                  <NunitoText
                                    value="Team Number"
                                    fontSize={20}
                                    fontWeight={600}
                                    align="left"
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "4%",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 2,
                                      height: 20,
                                      backgroundColor: "#000",
                                    }}
                                  />
                                </div>
                                <div style={{ width: "84%", marginTop: 0 }}>
                                  <ReusableTextField
                                    type="default"
                                    width={250}
                                    bgColor="#F2F2F2"
                                    borderColor="#707070"
                                    placeholder="Enter team number"
                                    state={team.teamNumber}
                                    setState={(value) =>
                                      updateTeam(team.id, "teamNumber", value)
                                    }
                                  />
                                </div>
                              </div>

                              {/* Participants Section */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                  marginBottom: "15px",
                                }}
                              >
                                <div style={{ width: "12%", marginTop: 0 }}>
                                  <NunitoText
                                    value="Participants"
                                    fontSize={20}
                                    fontWeight={600}
                                    align="left"
                                  />
                                </div>
                                <div
                                  style={{
                                    width: "4%",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 2,
                                      height: 20,
                                      backgroundColor: "#000",
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    width: "84%",
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "16px",
                                    alignItems: "flex-start",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  {team.participants.map(
                                    (participant, index) => (
                                      <div
                                        key={index}
                                        style={{ minWidth: "200px" }}
                                      >
                                        <ReusableTextField
                                          type="default"
                                          width={250}
                                          bgColor="#F2F2F2"
                                          borderColor="#707070"
                                          placeholder={`Participant ${
                                            index + 1
                                          }`}
                                          state={participant}
                                          setState={(value) =>
                                            updateTeamParticipant(
                                              team.id,
                                              index,
                                              value
                                            )
                                          }
                                        />
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </Grid>
                    ))}

                    {/* Add Extra Team Button */}
                    <Grid item xs={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                      >
                        <ReusableButton
                          text="Add Extra Team"
                          bgColor="#28a745"
                          fontSize={16}
                          height={50}
                          width={200}
                          iconType="add"
                          onClick={addExtraTeam}
                        />
                      </div>
                    </Grid>

                    {/* Save Button */}
                    <Grid item xs={12}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          width: "100%",
                          marginTop: "20px",
                        }}
                      >
                        <ReusableButton
                          text="Save All Team Members"
                          bgColor="#144A94"
                          fontSize={16}
                          height={50}
                          width={230}
                          onClick={() => handleSaveTeamMembers(teams)}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              ),
            },
            {
              label: "Upload Csv File",
              key: "UploadCsvFile",
              children: (
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems={"start"}
                  style={{ padding: 32 }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 20,
                    }}
                  >
                    <NunitoText
                      value="Only Upload CSV or XLSX File"
                      fontSize={20}
                      fontWeight={600}
                      color="#144A94"
                      align="left"
                    />

                    <div>
                      <input
                        type="file"
                        accept=".csv, .xlsx"
                        onChange={handleTeamMembersCsvFileChange}
                      />
                    </div>
                    <ReusableButton
                      text="Submit File"
                      bgColor="#144A94"
                      fontSize={14}
                      height={44}
                      width={140}
                      iconType="save"
                      onClick={() => handleUploadTeamMembersCsv()}
                      disabled={!csvFile}
                    />
                    {/* <button
                      onClick={() =>
                        handleUploadFile(
                          "competition/team-based/2025-simoc/mw/upload-answers",
                          file
                        )
                      }
                    >
                      Upload
                    </button> */}
                  </div>

                  <div style={{ width: 700 }}>
                    <p>
                      please make sure to add the csv header column like the
                      following Division , Team Number , Participant 1,
                      Participant 2, Participant 3, Participant 4, Participant
                      5,
                    </p>
                    <p>each team must have 4 or 5 participants</p>
                    <p>division must me on of the following LP, UP, LS, US</p>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: 20,
                        justifyContent: "flex-end",
                      }}
                    >
                      <ReusableButton
                        text="Download Sample Csv"
                        fontSize={15}
                        bgColor={"#5E75C3"}
                        height={46}
                        marginRight={30}
                        onClick={downloadSampleCsvTemplate}
                        iconType="download"
                      />
                    </div>
                  </div>
                </Grid>
              ),
            },
          ]}
        />
      </Grid>
    </Box>
  );
}
